export const URLS = {
    // url to get projects list
    PROJECT_LIST:'/project',
    GET_LOOKUP_DATA:'/misc/lookup',
    // url for update project collaborator
    UPDATE_PROJECT_COLLABORATOR: (projectId) => `/project/${projectId}/collaborators`,
    // url for delete project
    ARCHIVE_PROJECT:  `/project/archieve`,
    DELETE_PROJECT:  `/project`,
    //lock unlock project
    LOCK_PROJECT:(projectId) =>`/project/lock/${projectId}`,
    UNLOCK_PROJECT:(projectId) =>`/project/unlock/${projectId}`,
    GET_AUTHORIZED_USER:(projectId)=>`/project/validate/${projectId}`,
    // url for clone project
    CLONE_PROJECT: (projectId) => `/project/${projectId}/clone`,
    PROJECT_NAME_VALIDATION:`/project/exist`,
    // url to get user list
    USER_LIST: '/users',
    USER_DETAILS:`/user/me`,
    SCOPE_DATA:'/scope',
    CREATE_PROJECT:'/project',
    UPDATE_PROJECT:(projectId)=>`/project/${projectId}`,
    GET_PROJECT_DATA_FROM_PROJECT_ID:(projectId)=>`/project/${projectId}`,
    NEXT_STEP_UPDATE:(projectId)=>`/project/${projectId}/next-step`,
    CREATE_MVOC:(project_id)=>`/insight/mvoc/${project_id}`,
    SAVE_WAVE_PROMPT:(projectId)=>`/insight/mvoc/meta/${projectId}`,
    GET_MVOC_META_DATA:(projectId)=>`/insight/mvoc/meta/${projectId}`,
    UPLOAD:'/file/upload',
    GET_MVOC_DATA_FROM_PROJECT_ID:(projectId)=>`/insight/mvoc/${projectId}`,
    LOGOUT_URL:'/logout',
    TOKEN_VALIDATION:'/validate-token',
    REFRESH_TOKEN:'/refresh-token',
    FETCH_CHAT_GPT:(project_id,unified_id)=>`/genai/${project_id}/fetch/${unified_id}`,
    ACKNOWLEDGE_CHAT_GPT:(project_id)=>`/genai/${project_id}`,
    PROJECT_PROMPTS:(project_id)=>`/prompt/project/${project_id}`,
    DOWNLOAD_BLOB_FILE:'/blob/public/download',
    FILE_INACTIVE:(file_id,project_id)=> {
        return `/file/${file_id}/inactivate/${project_id}`;
    },
    SAVE_PROJECT_PROMPTS:(project_id)=>`/prompt/project/${project_id}`,
    GET_LONGITUDINAL_WAVE_DATA:(project_id)=>`/insight/mvoc/meta/longitudinal/${project_id}`,
    GET_LONGITUDINAL__DATA:(project_id)=>`/genai/analysis/longitudinal/${project_id}`,
  };